/** MUI */
import { alpha, Container, Grid, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import InfoWidgetSkeleton from "./InfoWidgetSkeleton";
import WidgetSkeleton from "./WidgetSkeleton";

const useStyles = makeStyles((theme) => ({
    skeleton: {
        backgroundColor: alpha(theme.palette.primary.light, 0.25),
    },
}));

const DashboardSkeleton = () => {
    const classes = useStyles();
    return (
        <Container maxWidth={false} disableGutters>
            <Grid container spacing={5}>
                <Grid item xs={12} lg={6}>
                    <Grid container spacing={5}>
                        {[1, 2, 3].map((w) => {
                            return (
                                <Grid item xs={12} lg={4} key={`${w}-InfoWidgetSkeleton`}>
                                    <InfoWidgetSkeleton />
                                </Grid>
                            );
                        })}

                        <Grid item xs={12}>
                            <WidgetSkeleton />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Grid container spacing={5}>
                        {[1, 2, 3, 4].map((w) => {
                            return (
                                <Grid item xs={12} lg={6} key={w}>
                                    <WidgetSkeleton chartHeight={88} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
};

export default DashboardSkeleton;
